import { useState } from 'react';
import { useAutoLogout } from '@/core/auth/useAutoLogout';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from '@/shared/ui/alert-dialog';
import { Button } from '@/shared/ui/button';
import { Checkbox } from '@/shared/ui/checkbox';

function formatTime(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function AutoLogoutWarningDialog() {
  const { showWarning, secondsRemaining, snooze, suspend, logoutNow } = useAutoLogout();
  const [suspendChecked, setSuspendChecked] = useState(false);

  const handleSnooze = () => {
    if (suspendChecked) {
      suspend();
    } else {
      snooze();
    }
    setSuspendChecked(false);
  };

  const handleLogout = () => {
    logoutNow();
  };

  return (
    <AlertDialog open={showWarning}>
      <AlertDialogContent
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Logout automatico programmato</AlertDialogTitle>
          <AlertDialogDescription>
            Il sistema si disconnettera automaticamente tra{' '}
            <span className="font-mono font-semibold text-foreground">
              {formatTime(secondsRemaining)}
            </span>
            .
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="flex items-center space-x-2 py-2">
          <Checkbox
            id="suspend-check"
            checked={suspendChecked}
            onCheckedChange={(checked) => setSuspendChecked(checked === true)}
          />
          <label
            htmlFor="suspend-check"
            className="text-sm font-medium leading-none cursor-pointer select-none"
          >
            Sospendi per 30 minuti
          </label>
        </div>

        <AlertDialogFooter>
          <Button variant="outline" onClick={handleSnooze}>
            {suspendChecked ? 'Sospendi 30 minuti' : 'Rimanda 5 minuti'}
          </Button>
          <Button variant="destructive" onClick={handleLogout}>
            Esci ora
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
